import { SET_TEMPLATE_FILES, CLEAR_TEMPLATE_FILES } from './whatsappTemplateFileTypes';

const initialState = {
    templateFiles: {},
    loading: false,
    error: null
};

export default function whatsappTemplateFileReducer(state = initialState, action) {
    switch (action.type) {
        case SET_TEMPLATE_FILES:
            return { ...state, templateFiles: action.payload };
        case CLEAR_TEMPLATE_FILES:
            return initialState;
        default:
            return state;
    }
}
